/**
 * main.ts — entry point. Imports the stylesheet, then initialises the five
 * interactive sections.
 *
 * Each section module owns its canvas/slider/button elements by ID and is
 * self-contained; main.ts just kicks them off after the DOM is parsed. The
 * init wrapper isolates failures so one broken section can't prevent the
 * others from wiring up — copied verbatim from gradient-demo's main.ts.
 */

import './style.css';
import { initR2 } from './r2';
import { initMse } from './mse';
import { initAccuracy } from './accuracy';
import { initPrecision } from './precision';
import { initROC } from './roc';

function boot(): void {
  const init = (name: string, fn: () => void): void => {
    try {
      fn();
    } catch (err) {
      console.error(`[main] ${name} failed to init:`, err);
    }
  };
  init('r2', initR2);
  init('mse', initMse);
  init('accuracy', initAccuracy);
  init('precision', initPrecision);
  init('roc', initROC);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
